import {useEffect} from 'react';
import {PublicService} from '../services/publicCatalogService';

export const usePublicCatalogSeo = (service: PublicService | null) => {
    useEffect(() => {
        if (!service) return;
        const title = document.title;
        document.title = `${service.nombre} | Co Marca Group`;
        let description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
        const created = !description;
        if (!description) {description = document.createElement('meta'); description.name = 'description'; document.head.appendChild(description);}
        const previous = description.content;
        description.content = service.descripcion.slice(0, 160);
        const canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = `https://comarcagroup.com/servicio/${service.slug}`;
        document.head.appendChild(canonical);
        const schema = document.createElement('script');
        schema.type = 'application/ld+json';
        schema.textContent = JSON.stringify({'@context': 'https://schema.org', '@type': 'Service',
            name: service.nombre, description: service.descripcion, url: canonical.href,
            provider: {'@type': 'Organization', name: 'Co Marca Group'}});
        document.head.appendChild(schema);
        return () => {document.title = title; if (created) description?.remove(); else if (description) description.content = previous; canonical.remove(); schema.remove();};
    }, [service]);
};
